import { Outlet } from "react-router-dom";
import { AuthShell, AuthContent } from "@/components/shell/auth-shell";
import { AuthShowcase } from "@/components/shell/auth-showcase";
import { AuthHeader } from "@/components/shell/auth-header";
import { AuthFooter } from "@/components/shell/auth-footer";

export function AuthLayout() {
  return (
    <AuthShell>
      <AuthShowcase />
      <AuthContent>
        <AuthHeader />
        <main className="relative flex w-full items-center justify-center">
          <Outlet />
        </main>
        <AuthFooter />
      </AuthContent>
    </AuthShell>
  );
}
